import createRoute   from '@widesk-ui/tools/createRoute';
import TaxonomyModel from '@models/shop/TaxonomyModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/taxonomies', 'shop', 'TaxonomyDashboard', TaxonomyModel.localize());
